import i18next from 'i18next';

/**
 * Mercury components translate through react-i18next, which Scribe does not use
 * app-wide. This scoped instance carries only the Icelandic strings the
 * BloodTestWorkspace reads; the sheet provides it via I18nextProvider.
 */
export const mercuryI18n = i18next.createInstance({
  lng: 'is',
  fallbackLng: 'is',
  initAsync: false,
  interpolation: { escapeValue: false },
  resources: {
    is: {
      translation: {
        lib: {
          mercury: {
            diagnosisSearchPlaceholder: 'Leita að rannsóknum...',
            noDiagnosisFound: 'Engar rannsóknir fundust',
            workspaceHeader: { bloodTest: 'Blóðprufupöntun', backButton: 'Til baka', skipButton: 'Sleppa' },
            completionRail: { bloodTestSteps: { confirmed: 'Staðfesta og senda' } },
            bloodTestWorkspace: {
              notes: 'Athugasemdir',
              notesPlaceholder: 'Sérstök fyrirmæli fyrir rannsóknarstofu...',
              selectedTests: 'Valdar rannsóknir',
              searchTests: 'Leita að rannsóknum',
              testList: 'Listi yfir rannsóknir',
              cost: 'Kostnaður:',
              currency: 'kr.',
              existingOrders: 'Fyrri pantanir',
              addRecommended: 'Bæta öllum við',
              draft: 'Drög',
              recommendedTests: 'Ráðlagðar rannsóknir:',
            },
            bloodTestCard: {
              autoIncluded: 'Fylgir sjálfkrafa með valinni rannsókn',
              includesTests: 'Inniheldur:',
              recommendsTests: 'Ráðleggur:',
            },
            selectedTagsList: { more: '+ {{count}} til viðbótar', showFewer: 'Sýna færri' },
          },
        },
      },
    },
  },
});

void mercuryI18n.init();
